import { uiaPerf, UiaRequestStats } from '../foundation';
import { useSyncExternalStore } from 'react';

/**
 * Subscribe to aggregated timing statistics for `/uia/*` API requests
 * (count, average, median, fastest, slowest, p95, last) plus the current
 * `navigator.connection` signal.
 *
 * The underlying collector must be started once at app bootstrap via
 * `uiaPerf.start()` (see `apps/player/src/main.tsx`); before that this hook
 * returns an empty snapshot.
 *
 * @returns The latest {@link UiaRequestStats} snapshot; the component re-renders
 * whenever a new `/uia/*` request completes or the connection changes.
 */
export const useUiaRequestStats = (): UiaRequestStats =>
    useSyncExternalStore(uiaPerf.subscribe, uiaPerf.getSnapshot, uiaPerf.getSnapshot);
